import script from "./DocumentDropZone.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentDropZone.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentDropZone.vue?vue&type=style&index=0&id=07b36dd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b36dd8"]])

export default __exports__